"use client";

import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom >= 0) {
          setScrollY(window.scrollY * 0.05);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={heroRef} className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/hvac_hero_background.png)",
      transform: `translateY(${scrollY}px)`
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-dark-background/60 via-transparent to-transparent" />

      {}
      <div ref={ref} className={`relative z-10 max-w-5xl mx-auto px-6 text-center transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-foreground-dark mb-6 leading-tight">
          Trusted HVAC Solutions for Pittsburgh
        </h1>
        <p className="text-xl md:text-2xl text-foreground-dark/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          Impeccable craftsmanship and customer satisfaction. Residential and commercial heating, cooling, and ventilation services you can rely on.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/ContactPage" className="btn-primary text-lg px-8 py-4">
            Schedule Service
          </Link>
          <Link to="/ServicesPage" className="inline-flex items-center justify-center rounded-md bg-background/80 backdrop-blur-sm text-foreground px-8 py-4 text-lg font-semibold transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:bg-background hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
            Our Services
          </Link>
        </div>
      </div>
    </section>;
}